export enum RoadType {
    Unknown,
    Motorway,
    DualCarriageway,
    SingleCarriageway,
    BuiltUpArea
}
